/**
 * Resolves the initial `differenceQuote` state on opportunity load.
 *
 * Priority:
 *   1. The saved DB value wins when explicitly set (true or false).
 *   2. Otherwise, defaults to true when the caller's role grants the
 *      DifferenceQuoteDefaultOn permission.
 *   3. Otherwise false.
 *
 * Applies to both brand-new opportunities (no saved row yet) and saved
 * opportunities with an unset difference_quote column.
 */
export function resolveInitialDifferenceQuote(
   savedDifferenceQuote: boolean | null | undefined,
   hasDefaultOnPermission: boolean,
): boolean {
   if (savedDifferenceQuote != null) return savedDifferenceQuote
   return hasDefaultOnPermission
}
